import React, { useState, useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import constants from 'shared/src/constants'

const TimeRemaining = ({
  reservation,
  onTimeout,
}) => {
  
  const [ secondsRemaining, setSecondsRemaining ] = useState(0)
  const [ timeRemaining, setTimeRemaining ] = useState('')
  const [ hasTriggedTimeout, setHasTriggedTimeout ] = useState(false)

  useEffect(() => {
    if(!reservation) return
    const calculate = () => {
      if(!reservation) return
      const date_now = new Date().getTime()
      const date_future = new Date(reservation.created_at).getTime() + (constants.SLOT_TIMEOUT_MINUTES * 60 * 1000)
      const rawGap = date_future - date_now
      var delta = Math.abs(date_future - date_now) / 1000
      const secondsRemaining = Math.floor(delta)
      setSecondsRemaining(secondsRemaining)
      if(rawGap < 0 && !hasTriggedTimeout) {
        setHasTriggedTimeout(true)
        onTimeout()
        clearInterval(intervalId)
      }
      // calculate (and subtract) whole days
      var days = Math.floor(delta / 86400)
      delta -= days * 86400

      // calculate (and subtract) whole hours
      var hours = Math.floor(delta / 3600) % 24
      delta -= hours * 3600

      // calculate (and subtract) whole minutes
      var minutes = Math.floor(delta / 60) % 60
      delta -= minutes * 60

      // what's left is seconds
      var seconds = Math.floor(delta % 60)

      setTimeRemaining(`${minutes < 10 ? '0' : ''}${minutes} min${minutes == 1 ? '' : 's'} ${seconds < 10 ? '0' : ''}${seconds} sec${seconds == 1 ? '' : 's'}`)
    }
    const intervalId = setInterval(calculate, 1000)
    return () => clearInterval(intervalId)
  }, [
    reservation,
    onTimeout,
  ])

  if(!reservation) return null

  return secondsRemaining < 0 ? (
    <div>
      <Typography variant="caption">This slot reservation has now expired.</Typography>
    </div>
  ) : (
    <div>
      {
        timeRemaining && (
          <>
            <Typography variant="caption">This slot has been reserved for:</Typography>
            <Typography><strong>{ timeRemaining }</strong></Typography> 
            <Typography variant="caption">You can cancel at any time for no charge.</Typography>
          </>
        )
      }
    </div>
  )
}

export default TimeRemaining